import type { Special } from "@/types/comic";

export const specials: Special[] = [
  {
    id: "editor-pick",
    title: "编辑精选",
    subtitle: "本周口碑最高的 5 部韩漫",
    desc: "由编辑团队精挑细选，综合读者评分与热度，本周最值得一看的韩漫合集。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20collage%20illustration%20of%20stacked%20Korean%20manhwa%20comic%20covers%20on%20a%20cream%20wooden%20desk%20with%20coffee%2C%20soft%20orange%20ambient%20light%2C%20cozy%20reading%20mood%2C%20clean%20minimal%20composition%2C%20detailed%20digital%20painting&width=1200&height=800&seq=special-editor-pick&orientation=landscape",
    comicIds: [
      "top-manager-secret",
      "sword-magic-dawn",
      "abyss-echo",
      "seoul-street-king",
      "reborn-actor",
    ],
  },
  {
    id: "romance-heart",
    title: "怦然心动",
    subtitle: "女生最爱的浪漫爱情全集",
    desc: "契约婚姻、双向暗恋、先婚后爱，甜甜的恋爱从这里开始。",
    cover:
      "https://readdy.ai/api/search-image?query=Dreamy%20romantic%20illustration%20of%20a%20couple%20under%20blooming%20cherry%20blossom%20trees%20at%20sunset%2C%20soft%20peach%20and%20pink%20petals%20floating%2C%20warm%20golden%20light%2C%20tender%20emotional%20mood%2C%20painterly%20digital%20art%2C%20wide%20cinematic%20composition&width=1200&height=800&seq=special-romance&orientation=landscape",
    comicIds: [
      "chaebol-contract-bride",
      "deskmate-genius",
      "blossom-girl-heart",
      "top-manager-secret",
    ],
  },
  {
    id: "battle-spirit",
    title: "热血战斗",
    subtitle: "燃到停不下来的动作爽漫",
    desc: "格斗、剑与魔法的极限对决，每一话都是高能名场面。",
    cover:
      "https://readdy.ai/api/search-image?query=Dynamic%20action%20illustration%20of%20an%20epic%20battle%20between%20a%20swordsman%20and%20a%20fighter%2C%20sparks%20and%20energy%20trails%2C%20warm%20orange%20and%20ember%20explosion%20tones%2C%20high%20motion%20impact%2C%20dramatic%20composition%2C%20webtoon%20digital%20painting&width=1200&height=800&seq=special-action&orientation=landscape",
    comicIds: [
      "seoul-street-king",
      "sword-magic-dawn",
      "doomsday-mecha",
      "midnight-detective",
    ],
  },
  {
    id: "binge-complete",
    title: "一口看完",
    subtitle: "已经完结，一次追到底",
    desc: "不用等更新，全本完结的韩漫合集，周末一次看到爽。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20illustration%20of%20a%20towering%20stack%20of%20finished%20comic%20volumes%20beside%20a%20warm%20reading%20lamp%20and%20a%20cup%20of%20tea%2C%20soft%20orange%20evening%20glow%2C%20relaxed%20marathon%20reading%20mood%2C%20clean%20composition%2C%20detailed%20digital%20painting&width=1200&height=800&seq=special-complete&orientation=landscape",
    comicIds: [
      "seoul-street-king",
      "chaebol-contract-bride",
      "campus-youth-chronicle",
    ],
  },
];